import React, { Component } from 'react';
import { loadModules } from 'esri-loader';
import { convertHex2Array } from "../../../utils";
import i18n from 'i18next';

export default class PointDraw extends Component {
    constructor(props) {
        super(props);
        this.state = {
            draw: null,
            editMode: false
        };
        this.action = null;
    }

    componentDidMount() {
        loadModules(['esri/views/draw/Draw', 'esri/widgets/Sketch/SketchViewModel']).then(([Draw, SketchViewModel]) => {
            if (!this.props.readOnly) {
                this.props.view.ui.remove("point-button");
                this.props.view.ui.add("point-button", 'bottom-left');

                const draw = new Draw({
                    view: this.props.view
                });

                // create a new sketch view model
                const sketchViewModel = new SketchViewModel({
                    view: this.props.view,
                    layer: this.props.map.findLayerById(this.props.layerId),
                    multipleSelectionEnabled: true
                });

                sketchViewModel.on(['create', 'update'], this.updateGraphic);

                this.setState({
                    draw
                });
                if (this.props.editMode ? this.props.editMode : false) {
                    this.handleCreate();
                }
            }

            if (this.props.point) {
                this.createPoint({ coordinates: [this.props.point.point.x, this.props.point.point.y] })
            }

            if (this.props.getOwnerOnFirstLoad) {
                const point = {
                    type: "point", // autocasts as /Point
                    x: this.props.point ? this.props.point.point.x : this.props.getOwnerOnFirstLoad.x,
                    y: this.props.point ? this.props.point.point.y : this.props.getOwnerOnFirstLoad.y,
                    spatialReference: this.props.view.spatialReference
                };

                //Wait for layers loaded
                setTimeout(() => {
                    this.handleGetOwner(point);
                }, 2000);
            }

        }).catch((err) => console.error(err));
    }

    componentWillUnmount() {
        this.props.view.ui.remove('point-button');
        this.props.view.ui.remove(this.state.draw);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        let isTypeChanged = JSON.stringify(nextProps.typeId) !== JSON.stringify(this.props.typeId);
        if (JSON.stringify(nextProps.point) !== JSON.stringify(this.props.point) || isTypeChanged) {
            if (nextProps.point && nextProps.point.point) {
                this.createPoint({ coordinates: [nextProps.point.point.x, nextProps.point.point.y] })
            }
        }
    }

    handleCreate = () => {
        if (!this.state.editMode) {
            // creates and returns an instance of PolyLineDrawAction
            this.action = this.state.draw.create("point");
            // focus the view to activate keyboard shortcuts for sketching
            this.props.view.focus();
            this.action.on(["draw-complete"], this.createPoint);
            this.setState({ editMode: true });
            if(this.props.afterDrawPoint) {this.props.afterDrawPoint();}
        } else {
            //New action without draw events
            this.action = this.state.draw.create("point");
            this.setState({ editMode: false });
        }

        this.props.view.graphics.removeAll();
    };

    handleGetOwner = (point) => {
        if (this.props.owner) {

            let setOwner = this.props.owner;

            if (this.props.map.allLayers.length === 0) {
                setOwner(false);
                return false;
            } else {
                let isOwnerFound = false;

                //Create responses map
                let neededResponseCount = 0;
                this.props.map.allLayers.map((layer, idx) => {
                    if (layer.type === 'feature') {
                        neededResponseCount++;
                    }
                    return true;
                });

                let currentResponseCount = 0; //Count received responses
                this.props.map.allLayers.map((layer, idx) => {
                    if (layer.type === 'feature') {
                        let query = layer.createQuery();
                        query.geometry = point;
                        query.spatialRelationship = "intersects";  // this is the default
                        query.returnGeometry = true;
                        query.outFields = ["*"];

                        layer.queryFeatures(query)
                            .then(function (response) {
                                currentResponseCount++;
                                if (response.features.length > 0) {
                                    if (response.features[0].attributes.hasOwnProperty('sde.tar.TKVRkatastriyksused.valitseja_nimi')) {
                                        setOwner(response.features[0].attributes);
                                        isOwnerFound = true;
                                        return false;
                                    }
                                }
                            }).catch(() => { //Not all queries has response
                                currentResponseCount++;
                            });
                    }
                    return true;
                });

                //Wait for all responses received
                let interval = setInterval(() => {
                    //All responses received!
                    if (currentResponseCount === neededResponseCount) {
                        clearInterval(interval);
                        if (!isOwnerFound) {
                            setOwner(false);
                        }
                    }
                }, 200);
            }
        }
    };


    createPoint = (event) => {
        loadModules(['esri/Graphic']).then(([Graphic]) => {
            this.props.map.findLayerById(this.props.layerId).graphics.removeAll();

            let x = 0;
            let y = 0;
            if (event.coordinates) {
                x = event.coordinates[0];
                y = event.coordinates[1];
            } else if (event.vertices && event.vertices.length === 1) {
                x = event.vertices[0][0];
                y = event.vertices[0][1];
            }

            const point = {
                type: "point", // autocasts as /Point
                x: x,
                y: y,
                spatialReference: this.props.view.spatialReference
            };

            let symbol = null;
            if (this.props.isCityObject) {
                if (this.props.type && this.props.type.icon) {
                    symbol = {
                        type: "picture-marker",
                        width: '42pt',
                        height: '42pt',
                        url: process.env.REACT_APP_API_V2 + "object_type/" + this.props.type.id + "/icon.svg?rand=" + new Date().getTime()
                            + (this.props.treeType ? ('&treeType=' + this.props.treeType) : ''),
                    };
                } else {
                    symbol = {
                        type: "simple-marker",
                        size: '14.1732pt',
                        color: this.props.type && this.props.type.color ? convertHex2Array(this.props.type.color, 0.7) : [255, 128, 0, 0.7],
                        outline: { color: 'grey', width: 0.5 }
                    };
                }
            } else {
                symbol = {
                    type: 'simple-marker',
                    outline: {
                        color: 'red',
                        width: 3
                    },
                    width: "32px",
                    height: "32px"
                }
            }

            const graphic = new Graphic({
                geometry: point,
                symbol: symbol,
            });

            this.props.map.findLayerById(this.props.layerId).graphics.add(graphic);

            if (event.type === 'draw-complete') {
                this.handleGetOwner(point);

                this.props.update({
                    type: graphic.geometry.type,
                    coordinates: [graphic.geometry.x, graphic.geometry.y]
                });

                this.setState({ editMode: false });
            }

        }).catch((err) => console.error(err));
    };

    updateGraphic = (event) => {
        if (event.state === 'cancel' || event.state === 'complete') {
            this.handleGetOwner(event.graphics[0].geometry);

            this.props.update({
                type: event.graphics[0].geometry.type,
                coordinates: [event.graphics[0].geometry.x, event.graphics[0].geometry.y]
            });
        }
    };

    render() {
        return (
            <div>
                <div
                    id="point-button"
                    onClick={this.handleCreate}
                    style={{ backgroundColor: this.state.editMode && '#f1c71a' }}
                    className={(this.props.readOnly && "d-none ") + "esri-widget esri-widget--button esri-interactive"}
                    title={i18n.t('common:map.addPoint')}
                >
                    <span className="esri-icon-map-pin" />
                </div>
            </div>
        )
    }
}
